import "styles/page.css";

import { handleOpenPdf } from "utils";
import { Link } from "react-router-dom";
import { ASSETS_BASE_URL } from "constants";
import axios from "axios";
import { isArray } from "lodash";
import { useEffect, useState } from "react";

function TermAndConditions() {
  const [tnc, setTnc] = useState([]);

  const fetchTermsAndConditions = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CMS_BASE_URL}/terms-and-conditions?sort=createdAt:asc&populate=*`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
          },
        }
      );
      // return response.data.data;
      setTnc(response.data.data);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    fetchTermsAndConditions();
  }, []);

  const latestTnc = [
    {
      name: "General Terms and Conditions - ENG",
      link: `${ASSETS_BASE_URL}assets/pdf/tnc/General_Terms_Conditions_ENG.pdf`,
      date: "September 2022",
    },
    {
      name: "General Terms and Conditions - BM",
      link: `${ASSETS_BASE_URL}assets/pdf/tnc/General_Terms_Conditions_BM.pdf`,
      date: "September 2022",
    },
    {
      name: "Specific Terms and Conditions - ENG",
      link: `${ASSETS_BASE_URL}assets/pdf/tnc/9 Specific Terms and Conditions 5th August 2024.pdf`,
      date: "5 August 2024",
    },
    {
      name: "Specific Terms and Conditions - BM",
      link: `${ASSETS_BASE_URL}assets/pdf/tnc/6 Specific Terms and Conditions BM.pdf`,
      date: "4 July 2023",
    },
    {
      name: "Internet and Mobile Banking Terms and Conditions",
      link: `${ASSETS_BASE_URL}assets/pdf/tnc/Internet and Mobile Banking Banking TC (Eff 21 July 2023).pdf`,
      date: "21 July 2023",
    },
  ];

  const previousTnc = [
    {
      name: "Specific Terms and Conditions - ENG",
      link: `${ASSETS_BASE_URL}assets/pdf/tnc/Specific_Terms_Conditions_13May24_ENG.pdf`,
      date: "13 May 2024",
    },
    {
      name: "Specific Terms and Conditions - ENG",
      link: `${ASSETS_BASE_URL}assets/pdf/tnc/6 Specific Terms and Conditions 4 July 2023 ENG (clean).pdf`,
      date: " 4 July 2023",
    },
    {
      name: "Specific Terms and Conditions - ENG",
      link: `${ASSETS_BASE_URL}assets/pdf/tnc/1 Eng - General Terms and Conditions - Liabilities Cards _ Aug 2022.pdf`,
      date: "August 2022",
    },
    {
      name: "Specific Terms and Conditions - ENG",
      link: `${ASSETS_BASE_URL}assets/pdf/tnc/Specific Terms and Conditions.pdf`,
      date: "02 May 2023",
    },
    {
      name: "Specific Terms and Conditions - BM",
      link: `${ASSETS_BASE_URL}assets/pdf/tnc/3 Specific Terms and Conditions 10 Jan 2023 BM.pdf`,
      date: "10 January 2023",
    },
    {
      name: "Internet and Mobile Banking Terms and Conditions",
      link: `${ASSETS_BASE_URL}assets/pdf/tnc/alrajhi24seven_Terms_and_Conditions.pdf`,
      date: "10 January 2023",
    },
  ];

  const supplementTnc = [
    {
      name: "Supplementary Terms and Conditions No. 1: JomPAY Standard Payer Terms",
      link: `${ASSETS_BASE_URL}assets/pdf/tnc/Supplementary_TC_JomPAY_Standard_Payer_Term.pdf`,
      date: "13 May 2024",
    },
    {
      name: "Supplementary Terms and Conditions No. 2: DuitNow Transfer Terms and Conditions",
      link: `${ASSETS_BASE_URL}assets/pdf/tnc/1677753434_Supplementary_TC_DuitNow_Transfer.pdf`,
      date: " 4 July 2023",
    },
    {
      name: "Supplementary Terms and Conditions No. 3: National Addressing Database (NAD) Terms and Conditions",
      link: `${ASSETS_BASE_URL}assets/pdf/tnc/Supplementary_TC_National_Addressing_Database_NAD.pdf`,
      date: "August 2022",
    },
    {
      name: "Supplementary Terms and Conditions No. 4: DuitNow QR Terms and Conditions",
      link: `${ASSETS_BASE_URL}assets/pdf/tnc/DuitNow_plus_QR_plus_Terms_plus_and_plus_Conditions-_plus_ver1Oct22.pdf`,
      date: "02 May 2023",
    },
    {
      name: "Supplementary Terms and Conditions No. 5: Terms of Business",
      link: `${ASSETS_BASE_URL}assets/pdf/tnc/Terms of Business Final 1NOV23.pdf`,
      date: "10 January 2023",
    },
  ];

  return (
    <>
      <style type="text/css">
        {`

            .tnc-page { 

                h1 {
                    color: var(--alrajhi-Brand-1000, #000045);
                    font-family: "Ping AR + LT";
                    font-size: 25px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 130%; /* 32.5px */
                    letter-spacing: -0.575px;
                }

                h2 {
                    color: var(--alrajhi-Brand-1000, #000045);
                    font-family: "Ping AR + LT";
                    font-size: 25px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 130%; /* 32.5px */
                    letter-spacing: -0.575px;
                }

                a {
                    color: var(--alrajhi-Brand-600, #221AFB);
                    font-family: "Ping AR + LT";
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 180%; /* 28.8px */
                    letter-spacing: -0.368px;
                }

                li {
                    color: var(--gray-500-body-text, #72788E);
                    font-family: "Ping AR + LT";
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 180%;
                    letter-spacing: -0.368px;
                }


                p {
                    color: var(--gray-500-body-text, #72788E);
                    font-family: "Ping AR + LT";
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 150%; /* 24px */
                    letter-spacing: -0.368px;
                }
            }

        `}
      </style>

      <div className="container tnc-page page">
        <h2>Terms and Conditions</h2>
        {tnc.map((item, index) => {
          return (
            <div className="py-3">
              <h1 className="mt-4 mb-3">
                {item.category}
              </h1>

              <ul>
              {isArray(item.tnc) && item.tnc.map((child, index) => (
                <li>
                  <Link onClick={() => handleOpenPdf(child.link)}>{child.name}</Link>{" "}
                  {child.date && <>(Effective: {child.date})</>}
                </li>
              ))}
              </ul>
              {item.notes && <p>{item.notes}</p>}
            </div>
          )
        })}
      </div>
    </>
  );
}

export default TermAndConditions;
